import { render, staticRenderFns } from "./CompaniesInput.vue?vue&type=template&id=b04f1404&scoped=true"
import script from "./CompaniesInput.vue?vue&type=script&lang=js"
export * from "./CompaniesInput.vue?vue&type=script&lang=js"
import style0 from "./CompaniesInput.vue?vue&type=style&index=0&id=b04f1404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f1404",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QIcon,QItemLabel});
